<template>
  <div class="Maps h-100">
    <Table
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="map"
      :options="options"
      :options2="options2"
      :func1="this.tier"
      :func2="this.type"
      filter1="Tier"
      filter2="Type"
      :smallScreen="smallScreen"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/Two-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Maps",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        {
          key: "name",
          sortable: false,
          thStyle: "width: 15%",
        },
        {
          key: "mapTier",
          sortable: false,
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "change",
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      options: [
        { text: "All", value: "All", disabled: false },
        { text: "1", value: "1", disabled: false },
        { text: "2", value: "2", disabled: false },
        { text: "3", value: "3", disabled: false },
        { text: "4", value: "4", disabled: false },
        { text: "5", value: "5", disabled: false },
        { text: "6", value: "6", disabled: false },
        { text: "7", value: "7", disabled: false },
        { text: "8", value: "8", disabled: false },
        { text: "9", value: "9", disabled: false },
        { text: "10", value: "10", disabled: false },
        { text: "11", value: "11", disabled: false },
        { text: "12", value: "12", disabled: false },
        { text: "13", value: "13", disabled: false },
        { text: "14", value: "14", disabled: false },
        { text: "15", value: "15", disabled: false },
        { text: "16", value: "16", disabled: false },
      ],
      options2: [
        { text: "All", value: "All", disabled: false },
        { text: "Normal", value: "Normal", disabled: false },
        { text: "Blight-ravaged", value: "Blight-ravaged", disabled: false },
        { text: "Blighted", value: "Blighted", disabled: false },
      ],
    };
  },
  mounted() {},

  methods: {
    getHref(item) {
      if (item != undefined) {
        if (item.name.includes("Map")) {
          if (item.name.includes("Blighted")) {
            let name = item.name.replace("Blighted ", "");
            return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"type":"${name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"map_filters":{"filters":{"map_tier":{"min":${item.mapTier},"max":${item.mapTier}},"map_elder":{"option":"false"},"map_shaped":{"option":"false"},"map_blighted":{"option":"true"}},"disabled":false},"type_filters":{"filters":{"category":{"option":"map"}},"disabled":false}}},"sort":{"price":"asc"}}`;
          } else {
            return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"filters":{"type_filters":{"filters":{"category":{"option":"map"}}},"map_filters":{"disabled":false,"filters":{"map_tier":{"min":${item.mapTier},"max":${item.mapTier}},"map_shaped":{"option":false},"map_elder":{"option":false},"map_blighted":{"option":false}}}},"type":{"option":"${item.name}"}}}`;
          }
        }
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"name":"${item.name}","stats":[{"type":"and","filters":[]}]},"sort":{"price":"asc"}}`;
      }
    },
    type(val, item) {
      if (val == "Blighted") {
        if (item.name.includes("Blighted")) {
          return true;
        }
        return false;
      } else if (val == "Blight-ravaged") {
        if (item.name.includes("Blight-ravaged")) {
          return true;
        }
        return false;
      } else {
        if (
          !item.name.includes("Blighted") &&
          !item.name.includes("Blight-ravaged")
        ) {
          return true;
        }
        return false;
      }
    },
    tier(val, item) {
      if (val == "All") {
        return true;
      } else {
        if (item.mapTier == val) {
          return true;
        }
        return false;
      }
    },
  },
  computed: {},
  watch: {},
};
</script>
